import { Host, h } from '@stencil/core';
export class AibaColumnWrapper {
  constructor() {
    this.data = undefined;
    this.componentWillLoadHandler = undefined;
    this.componentDidRenderHandler = undefined;
    this.handlers = undefined;
    this._id = undefined;
  }
  async componentWillLoad() {
    if (this.handlers && this.handlers[this.componentWillLoadHandler]) {
      const { data } = await this.handlers[this.componentWillLoadHandler](this.data);
      if (data)
        this.data = data;
    }
  }
  async componentDidRender() {
    if (this.handlers && this.handlers[this.componentDidRenderHandler]) {
      const { data } = (this.data = await this.handlers[this.componentDidRenderHandler](this.data));
      if (data)
        this.data = data;
    }
  }
  render() {
    var _a, _b, _c, _d;
    return (h(Host, { id: this._id ? this._id : '' }, ((_a = this.data) === null || _a === void 0 ? void 0 : _a.styles) && h("style", null, (_b = this.data) === null || _b === void 0 ? void 0 : _b.styles), h("div", { class: "column-wrapper-container" }, (_d = (_c = this.data) === null || _c === void 0 ? void 0 : _c.elements) === null || _d === void 0 ? void 0 : _d.map((wrapper, wrapperIndex) => {
      this.screen = wrapper.name;
      return (h("div", { class: "column-wrapper-item", "data-index": wrapperIndex }, h(this.screen, Object.assign({}, wrapper['data'], { handlers: this.handlers }))));
    }))));
  }
  static get is() { return "aiba-column-wrapper"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-column-wrapper.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-column-wrapper.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "componentWillLoadHandler": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "component-will-load-handler",
        "reflect": false
      },
      "componentDidRenderHandler": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "component-did-render-handler",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "_id": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "_id",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-column-wrapper.js.map
